// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import { BootstrapVue, BootstrapVueIcons } from 'bootstrap-vue'
import VueSweetalert2 from 'vue-sweetalert2'
import VueSession from 'vue-session'
import { library } from '@fortawesome/fontawesome-svg-core'
import { fas } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import { Base64 } from 'js-base64'
import axios from 'axios'
import { sha256 } from 'js-sha256'
import html2canvas from 'html2canvas'

import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'
import 'sweetalert2/dist/sweetalert2.min.css'

library.add(fas)

Vue.component('f-icon', FontAwesomeIcon)
Vue.use(VueSweetalert2)
Vue.use(BootstrapVue)
Vue.use(BootstrapVueIcons)
Vue.use(Base64)
Vue.use(VueSession)
// Vue.use(html2canvas)

// var options = {
//   persist: false
// }
// Vue.use(VueSession, options)

Vue.config.productionTip = false

Vue.prototype.$liff = window.liff
Vue.prototype.$liff_register_temple = '1655194154-BevzLOrD'

Vue.mixin({
  data () {
    return {
      headerLoginAPI: { 
        'application-key': 'MGY0ZDlhNGQxNDJkY2MzYTEyOTBiNThlZjFjOTJlOWIxYjU5ZjJhNDVkMzc4NzliYmY0OWViOWU4ZTZmZTZkZg==', 
        'Content-Type': 'application/json'
      },
      headerPrivateAPI: { 
        'application-key': 'NmRmMTY3MzIzYjU1ZjAyM2NmMTA1YzJlOGMxZjIyOTM2YTkzZDJhODQ4Y2E3NWNmZGUxNmVmNWRlNzgwMjY0ZA==', 
        'Content-Type': 'application/json'
      },
      headerAPI: { 
        'application-key': 'lX#KR&7Ji^;w:Z=jOA23uMaH_LfFNo)!p+^%wYS1bNUty$(TJB9)AxqLIHmRPkosZ!:akub;WVKjIGaxOyeD.p8q)z@shBgA*95c!Z', 
        'Content-Type': 'application/json'
      },
      logoName: 'ขอรับสิทธิ์ส่วนลดค่าธรรมเนียมการศึกษา',
      logoImg: 'https://pbs.twimg.com/media/Dq07-cxVsAElruQ?format=png&name=large',
      ipAddress: '',
      // footerHTML: '<div class="col-md-12"> <p class="mb-2">© สำนักงานศูนย์เทคโนโลยีสารสนเทศและการสื่อสาร มหาวิทยาลัยลัยธรรมศาสตร์ </p></div>'
      footerHTML: '<div class="col-md-12"> <p class="mb-2">© สำนักงานศูนย์เทคโนโลยีสารสนเทศและการสื่อสาร มหาวิทยาลัยลัยธรรมศาสตร์ </p> <p class="mb-2"><small>อาคารวิทยบริการ(สำนักงานใหญ่) 99 หมู่ที่ 18 ตำบลคลองหนึ่ง อำเภอคลองหลวง จังหวัดปทุมธานี 12121</small></p> </div>'
    }
  },
  methods: {
    getNowGlobal () {
      const today = new Date()
      const date =
        today.getDate() +
        '/' +
        (today.getMonth() + 1) +
        '/' +
        today.getFullYear()
        
      const time =
        today.getHours() +
        ':' +
        today.getMinutes()
        // ':' +
        // today.getSeconds() +
        // ':' +
        // today.getMilliseconds()
      const dateTime = 'วันที่ ' + date + ' เวลา ' + time + ' น.'
      return dateTime
    },
    getDataSessionUser () {
      let dataUser = {}
      let memberSession = this.$session.get('jwt')
      // console.log('getDataSessionUser memberSession', memberSession)
      let dataTime = new Date().getTime()

      if (memberSession) {
        dataUser = JSON.parse(memberSession)
        // console.log("User timeout :", new Date(dataUser.timeout))

        if (dataUser.timeout > dataTime) {
          // dataUser.timeout = dataTime + 900000
          return dataUser
        } else {
          this.$swal("หมดเวลา","หมดเวลาเข้าระบบ กรุณาเข้าระบบใหม่","error")
          return null
        }
      } else {
        return null
      }
    },
    getIPClient () {
      let ipSession = this.$session.get('adip')
      if (ipSession) {
        // let ipAddr = Base64.decode(ipSession)
        // console.log('getIPClient', ipSession, ipAddr)
        this.ipAddress = ipSession
      } else {
        axios
        .get('https://api.db-ip.com/v2/free/self')
        .then((response) => { 
          // console.log('getIPClient', response.data.ipAddress)
          // let ipen = Base64.encode(response.data.ipAddress)
          this.$session.start()
          this.$session.set('adip', response.data.ipAddress)
          this.ipAddress = response.data.ipAddress
        })
        .catch((error) => { 
          // console.log('getIPClient error', error) 
        })
      }
    },
    getHashKey (dt, type) {
      let hashKey = ''
      // console.log('dt', dt)
      if (dt.username) {
        hashKey = sha256(dt.username)

        // if (dt.cid) {
        //   // console.log('getHashKey', dt)
        //   hashKey = sha256(hashKey + dt.cid)
        //   hashKey = sha256(hashKey + dt.telephone)
        //   hashKey = sha256(hashKey + dt.status)
        // }
  
        if (type) {
          // console.log('getHashKey', type)
          
          if (type === 'Scholar_slip') {
            // console.log('Scholar_slip!!!')
            hashKey = sha256(hashKey + 'You_can_not_Scholar_slip!!!')
          } else if (type === 'refund_notice') {
            // console.log('Print_refund_notice!!!')
            hashKey = sha256(hashKey + 'You_can_not_Print_refund_notice!!!')
          } else {
            hashKey = sha256(hashKey + type)
            hashKey = sha256(hashKey + 'You_can_not_print_pdf_refund!!!')
          }
        } else {
          hashKey = sha256(hashKey + 'You_can_not_refund!!!')
          // hashKey = sha256(hashKey + 'You_can_not_Scholar_slip!!!')
          
        }
      } else {
        // console.log('getHashKey', type)
        hashKey = sha256(dt)
        hashKey = sha256(hashKey + type)
        hashKey = sha256(hashKey + 'You_can_not_Print_scholar_slip!!!')
      }

      return hashKey
    }
  }
})

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>'
})


// WEBPACK FOOTER //
// ./src/main.js